import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import profileApi from "../../api/profileApi";

const initialState = {
  profileLoading: false,
  stepCurrent: 0,
  profileData: null,
  qualifications: [],
  experiences: [],
  educations: [],
  certificates: [],
};

export const fetchProfile = createAsyncThunk(
  "profile/fetchProfile",
  async (_, { rejectWithValue }) => {
    try {
      const res = await profileApi.getProfile();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch profile" }
      );
    }
  }
);

export const updateProfile = createAsyncThunk(
  "profile/updateProfile",
  async (data, { rejectWithValue }) => {
    try {
      const res = await profileApi.updateProfile(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to update profile" }
      );
    }
  }
);

export const fetchQualifications = createAsyncThunk(
  "profile/fetchQualifications",
  async (_, { rejectWithValue }) => {
    try {
      const res = await profileApi.getQualifications();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch qualifications" }
      );
    }
  }
);

export const addQualification = createAsyncThunk(
  "profile/addQualification",
  async (data, { rejectWithValue }) => {
    try {
      const res = await profileApi.addQualification(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to add qualification" }
      );
    }
  }
);

export const updateQualification = createAsyncThunk(
  "profile/updateQualification",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await profileApi.updateQualification(id, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to update qualification" }
      );
    }
  }
);

export const deleteQualification = createAsyncThunk(
  "profile/deleteQualification",
  async (id, { rejectWithValue }) => {
    try {
      const res = await profileApi.deleteQualification(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to delete qualification" }
      );
    }
  }
);

export const fetchExperiences = createAsyncThunk(
  "profile/fetchExperiences",
  async (_, { rejectWithValue }) => {
    try {
      const res = await profileApi.getExperiences();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch experiences" }
      );
    }
  }
);

export const addExperience = createAsyncThunk(
  "profile/addExperience",
  async (data, { rejectWithValue }) => {
    try {
      const res = await profileApi.addExperience(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to add experience" }
      );
    }
  }
);

export const updateExperience = createAsyncThunk(
  "profile/updateExperience",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await profileApi.updateExperience(id, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to update experience" }
      );
    }
  }
);

export const deleteExperience = createAsyncThunk(
  "profile/deleteExperience",
  async (id, { rejectWithValue }) => {
    try {
      const res = await profileApi.deleteExperience(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to delete experience" }
      );
    }
  }
);

export const fetchEducations = createAsyncThunk(
  "profile/fetchEducations",
  async (_, { rejectWithValue }) => {
    try {
      const res = await profileApi.getEducations();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch educations" }
      );
    }
  }
);

export const addEducation = createAsyncThunk(
  "profile/addEducation",
  async (data, { rejectWithValue }) => {
    try {
      const res = await profileApi.addEducation(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to add education" }
      );
    }
  }
);

export const updateEducation = createAsyncThunk(
  "profile/updateEducation",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await profileApi.updateEducation(id, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to update education" }
      );
    }
  }
);

export const deleteEducation = createAsyncThunk(
  "profile/deleteEducation",
  async (id, { rejectWithValue }) => {
    try {
      const res = await profileApi.deleteEducation(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to delete education" }
      );
    }
  }
);

export const fetchCertificates = createAsyncThunk(
  "profile/fetchCertificates",
  async (_, { rejectWithValue }) => {
    try {
      const res = await profileApi.getCertificates();
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to fetch certificates" }
      );
    }
  }
);

export const addCertificate = createAsyncThunk(
  "profile/addCertificate",
  async (data, { rejectWithValue }) => {
    try {
      const res = await profileApi.addCertificate(data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to add certificate" }
      );
    }
  }
);

export const updateCertificate = createAsyncThunk(
  "profile/updateCertificate",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await profileApi.updateCertificate(id, data);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to update certificate" }
      );
    }
  }
);

export const deleteCertificate = createAsyncThunk(
  "profile/deleteCertificate",
  async (id, { rejectWithValue }) => {
    try {
      const res = await profileApi.deleteCertificate(id);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || { message: "Failed to delete certificate" }
      );
    }
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    handleStepCurrent: (state, action) => {
      state.stepCurrent = action.payload;
    },
    handleNextStep: (state) => {
      state.stepCurrent++;
    },
    handlePrevStep: (state) => {
      state.stepCurrent--;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.profileData = action.payload;
      })
      .addCase(fetchProfile.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(updateProfile.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.profileLoading = false;
      })
      .addCase(updateProfile.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(fetchQualifications.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(fetchQualifications.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.qualifications = action.payload || [];
      })
      .addCase(fetchQualifications.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(addQualification.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(addQualification.fulfilled, (state) => {
        state.profileLoading = false;
      })
      .addCase(addQualification.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(fetchExperiences.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(fetchExperiences.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.experiences = action.payload || [];
      })
      .addCase(fetchExperiences.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(addExperience.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(addExperience.fulfilled, (state) => {
        state.profileLoading = false;
      })
      .addCase(addExperience.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(fetchEducations.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(fetchEducations.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.educations = action.payload || [];
      })
      .addCase(fetchEducations.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(addEducation.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(addEducation.fulfilled, (state) => {
        state.profileLoading = false;
      })
      .addCase(addEducation.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(fetchCertificates.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(fetchCertificates.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.certificates = action.payload || [];
      })
      .addCase(fetchCertificates.rejected, (state) => {
        state.profileLoading = false;
      })

      .addCase(addCertificate.pending, (state) => {
        state.profileLoading = true;
      })
      .addCase(addCertificate.fulfilled, (state) => {
        state.profileLoading = false;
      })
      .addCase(addCertificate.rejected, (state) => {
        state.profileLoading = false;
      });
  },
});

export default profileSlice.reducer;
export const { handleStepCurrent, handleNextStep, handlePrevStep } =
  profileSlice.actions;
